import { FormEvent, useState, useEffect } from 'react';
import { Col, Container, Form, FormGroup, Input, Label, Row, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Btn, H2 } from '../../../../AbstractElements';
import { ForgotPassword, Password } from '../../../../Utils/Constants';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { useMutationRequestQuery } from '../../../../Hooks/useMutationRequestQuery';
import { clientLoginService } from '../../../../Services/Auth';
import { jwtDecode } from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { setUserData } from '../../../../ReduxToolkit/Reducers/AuthSlice';
import { useSafeNavigate } from '../../../../Hooks/useSafeNavigate';
import AppFooter from '../../../../CommonElements/AppFooter';

export default function MMPLogin() {
    const navigate = useSafeNavigate();
    const dispatch = useDispatch();
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [consent, setConsent] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);

    useEffect(() => {
        const policyAgree = localStorage.getItem('policyAgree');
        if (policyAgree === 'true') {
            setIsModalOpen(false);
        }
    }, []);

    const togglePasswordVisibility = () => setPasswordVisible(!isPasswordVisible);
    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const handleCancel = () => {
        toggleModal();
    };

    const { mutate: login, isPending } = useMutationRequestQuery(
        'clientLogin',
        clientLoginService,
        {
            onSuccess: (data: any) => {
                const decodedToken: any = jwtDecode(data?.data?.token);
                const sessionTime = decodedToken?.exp * 1000;
                localStorage.setItem('token', data?.data?.token);
                localStorage.setItem('policyAgree', 'true');
                localStorage.setItem('sessionTime', sessionTime.toString());
                if (rememberMe) {
                    localStorage.setItem('rememberedEmail', email);
                } else {
                    localStorage.removeItem('rememberedEmail');
                }

                // Dispatch user data to Redux immediately after login
                dispatch(setUserData({
                    nameidentifier: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
                    sub: decodedToken['sub'],
                    email: decodedToken['email'],
                    jti: decodedToken['jti'],
                    ContactNo: decodedToken['ContactNo'],
                    token: data?.data?.token,
                }));

                toast.success("Login successful!");
                handleCancel();
                navigate(`${process.env.PUBLIC_URL}/MMPDashboard`);
            },
            onError: (error: any) => {
                toast.error("Login failed. Please check your credentials.");
            },
        }
    );

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        if (!consent) {
            toast.error("Please consent to the terms and conditions");
            return;
        }
        const policyAgree = localStorage.getItem('policyAgree');
        if (policyAgree === 'true') {
            login({ email, password });
        } else {
            toggleModal();
        }
    };

    const handleAgree = () => {
        login({ email, password });
    };

    return (
        <Container className="p-0" fluid>
            <Row className="m-0">
                <Col xs={12} className="p-0">
                    <div className="login-card login-dark">
                        <div>
                            <div className="login-main">
                                <Form className="theme-form" onSubmit={handleSubmit}>
                                    <div className='text-center'>
                                        <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/fintrack_logo.png`}
                                            alt="Fintrack Logo"
                                            style={{ maxWidth: '230px', height: 'auto' }}
                                        />
                                    </div>
                                    <H2 className="text-center heading-color my-4">Mortgage Mastery Program</H2>
                                    <FormGroup>
                                        <Col><Label>Email</Label></Col>
                                        <Input
                                            type="email"
                                            value={email}
                                            onChange={(event) => setEmail(event.target.value)}
                                            required
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Col><Label>{Password}</Label></Col>
                                        <div className="form-input position-relative">
                                            <Input
                                                type={isPasswordVisible ? 'text' : 'password'}
                                                value={password}
                                                onChange={(event) => setPassword(event.target.value)}
                                                name="login[password]"
                                                required
                                            />
                                            {/* <div className='show-hide' onClick={togglePasswordVisibility}>
                                                {isPasswordVisible ? <FiEye style={{ cursor: 'pointer' }} size={20} /> : <FiEyeOff style={{ cursor: 'pointer' }} size={20} />}
                                            </div> */}

<div className='show-hide' onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }}>
  {isPasswordVisible ? (
    // Eye (show)
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <ellipse cx="10" cy="10" rx="8" ry="5" stroke="#333" strokeWidth="2"/>
      <circle cx="10" cy="10" r="2" fill="#333"/>
    </svg>
  ) : (
    // Eye with slash (hide)
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <ellipse cx="10" cy="10" rx="8" ry="5" stroke="#333" strokeWidth="2"/>
      <circle cx="10" cy="10" r="2" fill="#333"/>
      <line x1="4" y1="16" x2="16" y2="4" stroke="#333" strokeWidth="2"/>
    </svg>
  )}
</div>
                                        </div>
                                    </FormGroup>

                                    <div className="d-flex align-items-center gap-4 mb-3">
                                        <FormGroup check className="mb-0">
                                            <Input
                                                type="checkbox"
                                                checked={consent}
                                                onChange={(e) => setConsent(e.target.checked)}
                                                required
                                            />
                                            <Label check style={{ color: '#0d6efd' }}>I consent</Label>
                                        </FormGroup>

                                        <FormGroup check className="mb-0">
                                            <Input
                                                type="checkbox"
                                                checked={rememberMe}
                                                onChange={(e) => setRememberMe(e.target.checked)}
                                            />
                                            <Label check style={{ color: '#0d6efd' }}>Remember me</Label>
                                        </FormGroup>

                                        {/* <Link to="/forgotpassword" style={{ color: '#0d6efd', textDecoration: 'none' }}>
                                            Forgot Password
                                        </Link> */}
                                    </div>

                                    <p className="text-center mb-3" style={{ fontSize: '14px', color: '#6c757d' }}>
                                        By signing up or logging into the Mortgage Mastery Program you consent and agree
                                        to the <b><a href="https://www.fintrack.com.au/terms-conditions.html" target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'none', fontWeight: 'bold' }}>terms & conditions</a>, <a href="https://www.fintrack.com.au/privacy-policy.html" target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'none', fontWeight: 'bold' }}>privacy</a> and <a href="https://www.fintrack.com.au/disclaimer.html" target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'none', fontWeight: 'bold' }}>disclaimer</a></b> applicable to this program.
                                    </p>

                                    <FormGroup className="mb-0">
                                        <div className="text-end mt-3">
                                            <Btn color='primary' className="w-100" block type="submit" disabled={isPending}>{isPending ? "Loading . . ." : "Login"}</Btn>
                                        </div>
                                    </FormGroup>
                                    <div className="text-center mt-3">
                                        <span>Don't have an account? </span>
                                        <Link to="/MMPSignup">  Sign Up</Link>
                                    </div>
                                    <div style={{ fontSize: '12px', textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>
                                        <span>Copyright - {new Date().getFullYear()} - Fintrack Pty Ltd ACN 006 164 709.</span>
                                        <br />
                                        <span>All rights reserved.</span>
                                    </div>

                                    <div className="d-flex justify-content-between" style={{ fontSize: '14px' }}>
                                        <a href="https://www.fintrack.com.au/terms-conditions.html" target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'none', fontWeight: 'bold' }}>
                                            Terms & Conditions
                                        </a>
                                        <a href="https://www.fintrack.com.au/privacy-policy.html" target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'none', fontWeight: 'bold' }}>
                                            Privacy
                                        </a>
                                        <a href="https://www.fintrack.com.au/disclaimer.html" target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'none', fontWeight: 'bold' }}>
                                            Disclaimer
                                        </a>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Modal isOpen={isModalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Important Notice - Disclaimer </ModalHeader>
                <ModalBody>
                    By ticking this box, you consent, acknowledge and agree that this Software provides general information and is for educational purposes only. It does not claim or intend to provide financial advice or personal investment advice. Fintrack Pty Ltd ACN 006 164 709 recommend you obtain financial advice specific to your situation before making any financial investment or decision based on the information contained herein in this report. Fintrack Pty Ltd ACN 006 164 709 takes no responsibility nor accept any liability for any loss or damage arising from decisions made because of information contained in this software and urges readers to make full independent inquiries to make sure you are satisfied as the accuracy or completeness of the information that is provided herein this software. You also agree to allow us to remember you on this device.
                </ModalBody>
                <ModalFooter>
                    <Btn color="error" onClick={handleCancel}>Cancel</Btn>{' '}
                    <Btn color="success" onClick={handleAgree}>{isPending ? "Loading . . ." : "Agree"}</Btn>
                </ModalFooter>
            </Modal>
            <AppFooter />
        </Container>
    );
}
